import React from 'react';

const PagesIcon = <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width="24" height="24"><g><defs> </defs> <path fillRule="evenodd" clipRule="evenodd" d="M0,22h10V12H0V22z M0,10h10V0H0V10z M12,22h10V12H12V22z M12,0v10h10V0H12z" style={{ fill: 'white' }} vectorEffect="non-scaling-stroke" /> </g></svg>;

export default PagesIcon;